import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./ManagePropertyImages.css"; // Import CSS file

const ManagePropertyImages = () => {
  const { id } = useParams(); // Get the property ID from the URL
  const [images, setImages] = useState([]); // State to store images
  const imageUrlRef = useRef(null); // Using ref for the input field

  // Fetch property images on mount and when id changes
  useEffect(() => {
    fetchPropertyImages();
  }, [id]);

  // Function to fetch property images
  const fetchPropertyImages = async () => {
    try {
      const response = await axios.get(
        `https://realo-realestate.com/api/api/Property/GetPropertyImages/${id}/images`
      );
      setImages(response.data); // Set the images from the API response
    } catch (error) {
      console.error("Error fetching property images", error);
    }
  };

  // Handle adding a new image
  const handleAddImage = async () => {
    const imageUrl = imageUrlRef.current.value; // Ensure you're getting the image URL from input
    if (imageUrl) {
      try {
        await axios.post(
          `https://realo-realestate.com/api/api/Property/AddPropertyImage/${id}/images`,
          imageUrl,
          { headers: { "Content-Type": "application/json" } } // Set proper Content-Type
        );
        imageUrlRef.current.value = ""; // Clear the input after adding the image
        fetchPropertyImages(); // Refresh the list of images
      } catch (error) {
        console.error("Error adding property image", error);
      }
    }
  };

  // Handle deleting an image
  const handleDeleteImage = async (imageId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this image?"
    );
    if (confirmDelete) {
      try {
        await axios.delete(
          `https://realo-realestate.com/api/api/Property/DeletePropertyImage/${id}/images/${imageId}`
        );
        fetchPropertyImages(); // Refresh the images list after deletion
      } catch (error) {
        console.error("Error deleting property image", error);
      }
    }
  };

  return (
    <div>
      <h2>Manage Property Images</h2>
      <div className="image-grid">
        {images.map((image) => (
          <div key={image.imageId} className="image-item">
            <img src={image.imageUrl} alt={`Property ${image.imageId}`} />
            <button
              className="delete-button"
              onClick={() => handleDeleteImage(image.imageId)}
            >
              &times; {/* X or Close Icon */}
            </button>
          </div>
        ))}
      </div>
      <div>
        <input
          type="text"
          ref={imageUrlRef} // Use ref to access the input field value
          placeholder="New Image URL"
        />
        <button onClick={handleAddImage}>Add Image</button>
      </div>
    </div>
  );
};

export default ManagePropertyImages;
